var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{directives:[{name:"line-clamp",rawName:"v-line-clamp",value:(_vm.lineClamp),expression:"lineClamp"}],staticClass:"mb-2 t-sm description pr-3"},[_c('span',{staticClass:"t-600"},[_vm._v("Conditions/Diseases: ")]),_c('span',[_vm._v(_vm._s(_vm._f("separateByComma")(_vm.diseases,'term')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }